import {useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import {getViewTypeByName} from '../../../../../enums/ViewType';
import TableFunction from '../../../../../components/table/TableFunction';
import { useNavigate } from 'react-router-dom';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack
 * @Email : kpozos@ibl.mx
 *
 */
const DishesCardsApp = ({
    view,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    setIsAllChecked,
    option
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    // State variables for UI and logic
    const [searchResults, setSearchResults] = useState([]);
    const [searchElement, setSearchElement] = useState("");
    const [search, setSearch] = useState([]);
    const elementRef = useRef(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const viewType = getViewTypeByName(view);

    // On layout change, update a CSS variable with the element's top position
    useEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [searchResults]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            viewType: viewType,
        });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    }

    //pagination for list view
    const {
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        view,
        labelRowsPerPage: 'meals_per_page',
        setIsAllChecked,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        DEV,
        navigate,
        rowsPerPage,
        searchResults,
        setSearchResults,
        permission,
        elementRef,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        pagination
    };
};

export default DishesCardsApp;
